import { NgModule, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { NgxEchartsModule } from 'ngx-echarts';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

/* layouts */
import { DashboardLayoutComponent } from './layouts/dashboard-layout/dashboard-layout.component';

/* components */
import { SideBarComponent } from './components/side-bar/side-bar.component';
import { MenuItemComponent } from './components/menu-item/menu-item.component';
import { MainHeaderComponent } from './components/main-header/main-header.component';
import { SectionTitleComponent } from './components/section-title/section-title.component';
import { PillTitleComponent } from './components/pill-title/pill-title.component';
import { NpsBreakdownComponent } from './components/nps-breakdown/nps-breakdown.component';
import { FilterPanelComponent } from './components/filter-panel/filter-panel.component';
import { MultiSelectComponent } from './components/multi-select/multi-select.component';
import { DataTableComponent } from './components/data-table/data-table.component';
import { ChartComponent } from './components/chart/chart.component';
import { MapChartComponent } from './components/map-chart/map-chart.component';
import { ModalComponent } from './components/modal/modal.component';
import { HistoryModalComponent } from './components/history-modal/history-modal.component';
import { StatCardComponent } from './components/stat-card/stat-card.component';
import { SectionTabsComponent } from './components/section-tabs/section-tabs.component';
import { FilterBarComponent } from './components/filter-bar/filter-bar.component';
import { DateRangeComponent } from './components/date-range/date-range.component';

/* pages */
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { PulsePageComponent } from './pages/pulse-page/pulse-page.component';
import { ExplorePageComponent } from './pages/explore-page/explore-page.component';
import { VoicePageComponent } from './pages/voice-page/voice-page.component';
import { ActionsPageComponent } from './pages/actions-page/actions-page.component';
import { ProgramPageComponent } from './pages/program-page/program-page.component';

@NgModule({
  declarations: [
    AppComponent,

    DashboardLayoutComponent,

    SideBarComponent,
    MenuItemComponent,
    MainHeaderComponent,
    SectionTitleComponent,
    PillTitleComponent,
    NpsBreakdownComponent,
    FilterPanelComponent,
    MultiSelectComponent,
    DataTableComponent,
    ChartComponent,
    MapChartComponent,
    ModalComponent,
    HistoryModalComponent,
    StatCardComponent,
    SectionTabsComponent,
    FilterBarComponent,
    DateRangeComponent,

    LoginPageComponent,
    PulsePageComponent,
    ExplorePageComponent,
    VoicePageComponent,
    ActionsPageComponent,
    ProgramPageComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    AppRoutingModule,
    NgxEchartsModule.forRoot({ echarts: () => import('echarts') }),
  ],
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withFetch()),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
